module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "calendar_after_dark.b57ab557.png" + "?" + Date.now();